import { z } from 'zod';
import { EmptyObject } from 'libs/end-to-end/src/generic';
import { createCustomVizRequestSchema } from 'libs/end-to-end/src/custom-viz/createCustomVizRequestSchema';
import { FocusArea } from 'libs/end-to-end/src/focus-area';
import { FilterDefinitionForExtras } from 'libs/end-to-end/src/types/databases/filters/filter-definition';

export const BinScatterCrossSelectInputs = z.object({
  dropdowns: EmptyObject,
  extras: z.object({
    focusArea: FocusArea,
    metric: z.string(),
    dimension: z.string(),
    group1: z.object({
      dimension1: FilterDefinitionForExtras,
      dimension2: FilterDefinitionForExtras,
    }),
    group2: z.object({
      dimension1: FilterDefinitionForExtras,
      dimension2: FilterDefinitionForExtras,
    }),
  }),
});

export const BinScatterCrossSelectRequest = createCustomVizRequestSchema(
  'binScatterCrossSelect',
  BinScatterCrossSelectInputs,
);

export type BinScatterCrossSelectRequest = z.infer<
  typeof BinScatterCrossSelectRequest
>;
